<script setup lang="ts">
import { ArrowRight } from "@iconoir/vue";
import { type RouterLinkProps } from "vue-router";
import IconButtonLink from "./IconButtonLink.vue";

defineProps<RouterLinkProps>();
</script>

<template>
  <IconButtonLink v-bind="$props" alt="Teilnehmen">
    <ArrowRight />
  </IconButtonLink>
</template>
